import React from 'react'

const AppMobile = () => {
  return (
    <div>
      success
    </div>
  )
}

export default AppMobile
